import { FormList, HeaderTitle, Operation, OverItem, ExportData } from '@/components';
import { calcPrice, parseJSON, toDateTime } from '@/utils/utils';
import { getOrderOevr, getOrderStore, postOrderUpdate } from '@/api';
import { Col, DatePicker, message, Modal, Table } from 'antd';
import React, { useState, useEffect } from 'react';
import { st_order } from '@/utils/statetype';
import { useTable } from '@/hooks';
import moment from 'moment';
import { result } from 'lodash';

const { statusObj, typeObj } = st_order;
function OrderList({ history, querys }) {
  const { s: p_s } = querys;
  const [query, setQuery] = useState({});
  const [count, setCount] = useState([]);
  const [visible, setVisible] = useState(null);
  const [autoCancelTime, setAutoCancelTime] = useState(null);

  const columns = {
    id: '订单编号',
    number: '订单号',
    NOINDEX_OrderSPuId: {
      title: '商品编号',
      render: e => {
        const [info = {}] = e.OrderSkus || [];
        const { spuId } = info || {};
        return spuId || '-';
      },
    },
    NOINDEX_OrderSKuId: {
      title: 'sku编号',
      render: e => {
        const [info = {}] = e.OrderSkus || [];
        const { skuId } = info || {};
        return skuId || '-';
      },
    },
    userId: '用户编号',
    OrderSkus: {
      title: '商品名称',
      render: (e = []) => {
        const [info = {}] = e;
        const { photo } = info || {};
        const { spu } = parseJSON(photo) || {};
        const { name } = spu || {};
        return name || '-';
      },
    },
    NOINDEX_startPrice: {
      title: '起拍价',
      render: e => {
        const [info = {}] = e?.OrderSkus || [];
        const { photo } = info || {};
        const { sku } = parseJSON(photo) || {};
        const { startPrice, type } = sku || {};
        return (startPrice && (type == 10 || type == 30)) ? calcPrice(startPrice) : '-';
      },
    },
    NOINDEX_finalPrice: {
      title: '成交价',
      render: e => {
        const [info = {}] = e?.OrderSkus || [];
        const { photo } = info || {};
        const { sku } = parseJSON(photo) || {};
        const { finalPrice } = sku || {};
        return finalPrice ? calcPrice(finalPrice) : '-';
      },
    },
    NOINDEX_premiumPrice: {
      title: '商品差价',
      render: e => {
        const [info = {}] = e?.OrderSkus || [];
        const { premiumPrice } = info || {};
        return premiumPrice ? calcPrice(premiumPrice) : '-';
      },
    },
    NOINDEX_subscriptionPrice: {
      title: '认购价',
      render: e => {
        const [info = {}] = e?.OrderSkus || [];
        const { photo } = info || {};
        const { sku } = parseJSON(photo) || {};
        const { subscriptionPrice } = sku || {};
        return subscriptionPrice ? calcPrice(subscriptionPrice) : '-';
      },
    },
    NOINDEX_contributionPrice: {
      title: '贡献值',
      render: e => {
        const [info = {}] = e?.OrderSkus || [];
        const { photo } = info || {};
        const { sku } = parseJSON(photo) || {};
        const { contributionPrice } = sku || {};
        return contributionPrice ? calcPrice(contributionPrice) : '-';
      },
    },
    merchantId: '店铺编号',
    Merchant: {
      title: '店铺名称',
      render: e => (e || {}).title || '-',
    },
    type: {
      title: '订单类型',
      render: e => typeObj[e] || '-',
    },
    status: {
      title: '订单状态',
      render: (e, { type }) => {
        if (e === -1) {
          return [20, 30].includes(type) ? '已违约' : '已取消';
        }
        return statusObj[e] || '-';
      },
    },
    resellUserId: '转拍人编号',
    shouldPayPrice: {
      title: '应付金额',
      render: e => calcPrice(e),
    },
    payPrice: {
      title: '实付金额',
      render: e => calcPrice(e),
    },
    payTime: {
      title: '支付时间',
      render: e => toDateTime(e),
    },
    autoCancelTime: {
      title: '自动取消时间',
      render: e => toDateTime(e),
    },
    createdAt: {
      title: '创建时间',
      render: e => toDateTime(e),
    },
    NOINDEX_operation: {
      title: '操作',
      fixed: 'right',
      render: e => (
        <Operation
          disabled={{
            delayed: ![10, -1].includes(e.status),
          }}
          listData={{
            select: () => history.push(`/order/list/detail?i=${e.id}`),
            delayed: () => setVisible(e),
          }}
        />
      ),
    },
  };

  const { tableProps, flagFn } = useTable({
    columns,
    API: getOrderStore,
    isInit: false,
    params: {
      query,
    },
  });

  const formData = [
    {
      id: 'userId',
      label: '用户编号',
    },
    {
      id: 'id',
      label: '订单编号',
    },
    {
      id: 'merchantId',
      label: '店铺编号',
    },
    {
      id: 'resellUserId',
      label: '转拍人编号',
    },
    {
      id: 'number',
      label: '订单号',
    },
    {
      id: 'spuId',
      label: '商品编号',
    },
    {
      id: 'merchantName',
      label: '店铺名称',
    },
    {
      id: 'premiumPriceMin',
      label: '竞拍差价范围最小值',
    },
    {
      id: 'premiumPriceMax',
      label: '竞拍差价范围最大值',
    },
    {
      id: 'status',
      label: '订单状态',
      type: 'select',
      selects: statusObj,
      ...(p_s ? { initialValue: String(p_s) } : {}),
      options: {
        mode: 'multiple',
        maxTagCount: 1,
      },
    },
    {
      id: 'type',
      label: '订单类型',
      type: 'select',
      selects: typeObj,
      options: {
        mode: 'multiple',
        maxTagCount: 1,
      },
    },
    {
      id: 'createdAt',
      label: '创建时间',
      type: 'rangeTime',
    },
  ];

  useEffect(() => {
    getOrderOevr().then(res => {
      const countData = [
        ['待发货订单量', res.waitSendCount],
        ['待支付订单量', res.waitCount],
        ['认购订单量', res.subscriptionCount],
        ['拍卖订单量', res.auctionCount],
        ['违约单量', res.cancelCount],
      ];
      setCount(countData);
    });
  }, []);

  const changeQuery = (value = {}) => {
    const { createdAt, status = [p_s], type = [20, 25, 30, 40, 45], premiumPriceMin, premiumPriceMax, ...props } = value;
    const [start, end] = createdAt || [];
    console.log("props", props, value, p_s)
    const q = {
      ...props,
      // status: status.join(','),
      type: type.join(','),
      // premiumPriceMin: premiumPriceMin ? premiumPriceMin * 100 : "",
      // premiumPriceMax: premiumPriceMax ? premiumPriceMax * 100 : "",
      ...(createdAt && {
        startTime: toDateTime(start),
        endTime: toDateTime(end),
      }),
    };
    if (status?.join(',')) q.status = status.join(',')
    if (premiumPriceMin) q.premiumPriceMin = premiumPriceMin * 100
    if (premiumPriceMax) q.premiumPriceMax = premiumPriceMax * 100
    setQuery(q);
    flagFn(true);
  };

  const disabledDate = current => {
    return current < moment().subtract(1, 'days');
  };

  const handleClickItem = index => {
    let q = {};
    switch (index) {
      case 0:
        q = { status: '30', type: '20,25,30,40' };
        break;
      case 1:
        q = { status: '10', type: '20,25,30,40' };
        break;
      case 2:
        q = { type: '40' };
        break;
      case 3:
        q = { type: '20,25,30' };
        break;
      case 4:
        q = { status: '-1', type: '20,25,30,40' };
        break;
    }
    setQuery(q);
    flagFn(true);
  };

  const excelDataParse = row => {
    let OrderSku = row?.OrderSkus[0]
    let photoObj
    try {
      photoObj = JSON.parse(OrderSku.photo)
      if (row?.type == 40) {
        photoObj.sku.startPrice = 0
      }
    } catch (error) {
      console.log("photo parse err:", error)
    }
    row.OrderSku = {
      ...OrderSku,
      photo: photoObj,
    }
  };

  return (
    <>
      <HeaderTitle
        addLabel={
          p_s
            ? {
              label: statusObj[p_s],
              tips: '点击查看全部订单',
              onClick: () => location.replace('/order/list'),
            }
            : null
        }
      />
      <OverItem datas={count} width={'20%'} onClick={handleClickItem} />
      <FormList formData={formData}
        changeQuery={changeQuery}
        extraRender={
          <ExportData
            title="订单列表"
            API={getOrderStore}
            query={query}
            dataParse={excelDataParse}
            extend={{
              status: statusObj,
              type: typeObj,
              status: statusObj,
              createdAt: "time",
              payTime: "time",
              autoCancelTime: "time",
              "OrderSku.photo.sku.startPrice": "amount",
              "OrderSku.photo.sku.finalPrice": "amount",
              "OrderSku.premiumPrice": 'amount',
              "OrderSku.photo.sku.subscriptionPrice": 'amount',
              "OrderSku.photo.sku.contributionPrice": 'amount',
              shouldPayPrice: 'amount',
              payPrice: 'amount',
              // OrderSku: (info = []) => {
              //   let OrderSku = info[0] || {}
              //   let photo = JSON.parse(OrderSku?.photo || { spu: {} })
              //   return `商品编号:${OrderSku.spuId},sku编号:${OrderSku.skuId},商品名称:${photo.spu.name},商品差价:${calcPrice(OrderSku.premiumPrice)}`
              // },
            }}
            columns={{
              id: '订单编号',
              number: '订单号',
              'OrderSku.spuId': '商品编号',
              'OrderSku.skuId': 'sku编号',
              userId: '用户编号',
              "OrderSku.photo.spu.name": '商品名称',
              "OrderSku.photo.sku.startPrice": '起拍价',
              "OrderSku.photo.sku.finalPrice": '成交价',
              "OrderSku.premiumPrice": '商品差价',
              "OrderSku.photo.sku.subscriptionPrice": '认购价',
              "OrderSku.photo.sku.contributionPrice": '贡献值',
              // 'OrderSku': '商品信息',
              'Merchant.id': '店铺编号',
              'Merchant.title': '店铺名称',
              type: '订单类型',
              status: '订单状态',
              resellUserId: '转拍人编号',
              shouldPayPrice: '应付金额',
              payPrice: '实付金额',
              payTime: '支付时间',
              autoCancelTime: '自动取消时间',
              createdAt: '创建时间',
              // 'Spu.resellCount': '转拍次数',

            }}
          />
        }
      />
      <Table {...tableProps} />
      <Modal
        visible={!!visible}
        title="延时订单过期时间"
        onCancel={() => setVisible(null)}
        onOk={() => {
          if (!autoCancelTime) {
            message.warning('请选择时间');
            return;
          }
          postOrderUpdate({
            body: {
              id: visible.id,
              operateType: 1,
              status: visible.status,
              autoCancelTime: toDateTime(autoCancelTime),
            },
          }).then(() => {
            setVisible(null);
            message.success('调整成功');
            flagFn();
          });
        }}
      >
        <Col>
          自动取消时间：
          <DatePicker showTime disabledDate={disabledDate} onChange={e => setAutoCancelTime(e)} />
        </Col>
      </Modal>
    </>
  );
}

export default OrderList;
